<template>
    <label
        :key="value"
        :class="$style.radio_wrapper"
    >
        <input
            type="radio"
            name="duration"
            :value="value"
            :checked="checked"
        />
        <span :class="$style.radio_mark" />
        <span :class="$style.radio_content">
            <Typography
                :responsive="false"
                type="label"
                size="m"
            >
                {{ $tr('disabledAd.duration', +value) }}
            </Typography>
            <Typography
                :class="$style.radio_sublabel"
                :responsive="false"
                type="label"
                size="xs"
            >
                {{ label }}
            </Typography>
        </span>
    </label>
</template>
<script setup lang="ts">
import Typography from '@/components_new/Typography.vue'

defineProps<{
    label: string
    value: string
    checked: boolean
}>()
</script>

<style module>
.radio_wrapper {
    display: flex;
    height: 32px;
    padding: 16px;
    align-items: center;
    gap: 12px;
    border-radius: var(--radius-16);
    background: var(--carbon-400);
    cursor: pointer;
}

.radio_wrapper input {
    display: none;
}

.radio_mark {
    box-sizing: border-box;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: var(--carbon-400);
    border: 1px solid var(--white-40);
}

.radio_wrapper input[type='radio']:checked + .radio_mark {
    background: var(--white);
    border: 10px solid var(--purple-400);
}

.radio_content {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.radio_sublabel {
    color: var(--white-40);
}
</style>
